<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import FilterBar from '@lib/components/shared/FilterBar.vue'
import BInput from '@lib/components/base/BInput.vue'
import type { DeviceFilters } from '@/composables/useDevicesData'

const props = defineProps<{ modelValue: DeviceFilters }>()
const emit = defineEmits<{
    (e: 'update:modelValue', v: DeviceFilters): void
    (e: 'clear'): void
}>()

const { t } = useI18n()

const activeCount = computed(() => (props.modelValue.search ? 1 : 0))

function update<K extends keyof DeviceFilters>(key: K, value: DeviceFilters[K]) {
    emit('update:modelValue', { ...props.modelValue, [key]: value })
}
</script>

<template>
    <FilterBar :active-count="activeCount" @clear="$emit('clear')">
        <label class="block">
            <span class="text-xs text-gray-600 mb-1 block">{{ t('devices.filter.search') }}</span>
            <BInput
                :model-value="modelValue.search"
                :placeholder="t('devices.filter.search')"
                @update:model-value="v => update('search', v)"
            />
        </label>
    </FilterBar>
</template>
